export default __webpack_public_path__ + "static/media/info.0de127c0.svg";